<div class="student-page">
    <h1 class="title">All Students</h1>
    <p class="subtitle">View and manage enrolled students</p>
    <div class="top-bar">
        <!-- Search -->
        <input type="text" class="search-input" placeholder="Search by Name or Email" [(ngModel)]="searchText"
            (ngModelChange)="searchStudent($event)" />

        <!-- CLASSROOM FILTER -->
        <ng-container>

            <!-- Show select only when ALL is selected -->
            <div class="select-wrapper" *ngIf="selectedClassroom === 0">
                <select class="filter-select" [(ngModel)]="selectedClassroom" (change)="applyFilter()">

                    <option *ngFor="let c of classrooms" [ngValue]="c.id">
                        {{ c.name }}
                    </option>
                </select>

                <i class="bi bi-chevron-down select-arrow"></i>
            </div>

            <!-- Show chip when a classroom is selected -->
            <div class="filter-chip" *ngIf="selectedClassroom !== 0">
                Classroom: <span>{{ getClassroomName(selectedClassroom) }}</span>
                <span class="close-icon" (click)="clearClassroom()">✕</span>
            </div>

        </ng-container>

        <!-- DEPARTMENT FILTER -->
        <ng-container>

            <div class="select-wrapper" *ngIf="selectedDepartment === 0">
                <select class="filter-select" [(ngModel)]="selectedDepartment" (change)="applyFilter()">

                    <option *ngFor="let d of departments" [ngValue]="d.id">
                        {{ d.name }}
                    </option>
                </select>

                <i class="bi bi-chevron-down select-arrow"></i>
            </div>

            <div class="filter-chip" *ngIf="selectedDepartment !== 0">
                Department: <span>{{ getDepartmentName(selectedDepartment) }}</span>
                <span class="close-icon" (click)="clearDepartment()">✕</span>
            </div>

        </ng-container>

        <!-- BATCH FILTER -->
        <ng-container>

            <div class="select-wrapper" *ngIf="selectedBatch === 0">
                <select class="filter-select" [(ngModel)]="selectedBatch" (change)="applyFilter()">

                    <option *ngFor="let b of batches" [ngValue]="b.id">
                        {{ b.name }}
                    </option>
                </select>

                <i class="bi bi-chevron-down select-arrow"></i>
            </div>

            <div class="filter-chip" *ngIf="selectedBatch !== 0">
                Batch: <span>{{ getBatchName(selectedBatch) }}</span>
                <span class="close-icon" (click)="clearBatch()">✕</span>
            </div>

        </ng-container>

    </div>
    <div class="table-card">
        <table class="student-table">
            <thead>
                <tr>
                    <th>S.NO</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Batch</th>
                    <th>Department</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="students.length > 0; else noStudents">
                    <tr *ngFor="let s of students; let i = index">
                        <td>{{ (page - 1) * limit + i + 1 }}</td>
                        <td class="student-name">{{ s.name }}</td>
                        <td>{{ s.email || '-' }}</td>
                        <td>{{ s.batch || '-' }}</td>
                        <td>{{ s.department || '-' }}</td>
                    </tr>
                </ng-container>

                <ng-template #noStudents>
                    <tr>
                        <td colspan="5">
                            <div class="empty-row">No students found</div>
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table>

        <p-paginator [rows]="limit" [totalRecords]="totalRecords" [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100]"
            (onPageChange)="onPageChange($event)">
        </p-paginator>

    </div>
</div>